import { MathUtils, Vector3 } from "three";
import { assets } from "./Assets";
import CameraManager from "./CameraManager";
import Farm from "./Farm";
import { Human, HumanTypes } from "./Human";
import Tent from "./Tent";
import { Transform as CameraSettings } from "./Transform";
import Tree, { TreeTypes } from "./Tree";
import useScene from "./UseScene";
import useScrollCameraEffect from "./UseScrollCameraEffect";
import { Horse, HorseHair } from "./Horse";
import { useFrame } from "@react-three/fiber";
import { useState } from "react";
import useEventDispatcher from "../stores/useEventDispatcher";
import { randInt } from "three/src/math/MathUtils";

export default function BirthdayScene() {

    const [nextEvt] = useState({ t: 2 });

    useScene("/birthday");

    useScrollCameraEffect(new Vector3(0.31, 1, 5.3));

    const fireEvent = useEventDispatcher(s => s.fireEvent);

    useFrame((_s, d) => {
        let remaining = nextEvt.t - d;
        if (remaining < 0) {
            fireEvent("barrel");
            remaining = randInt(3, 10);
        }
        nextEvt.t = remaining;
    })

    return <>
        <CameraManager
            original={new CameraSettings(-13.31, 3.83, 13.3, 0, 3, 0)}
            explore={new CameraSettings(19, 11, 18, 0, 0, 0)}
            landscape={new CameraSettings(-13.31, 3.83, 13.3, 0, 3, 0)}
            portrait={new CameraSettings(-23.05, 10, 43.57, 0, 10, 1.5)}
            // orbitCtrl
            makeDefault
            rotateSpeed={0.25}
            minPolarAngle={Math.PI * 0.2}
            maxPolarAngle={Math.PI * 0.45}
            minAzimuthAngle={Math.PI * -0.4}
            maxAzimuthAngle={Math.PI * 0.4}
            maxDistance={60}
            minDistance={10}
            maxZoom={10}
            minZoom={1}
            enableDamping
            enablePan={true}
            dampingFactor={0.05}

        />
        <Tent />
        <Tree
            position={[9.44, -0.25, 2.34]}
            rotation={[0, 187.22, 0]}
            scale={1.403}
        />
        <Tree
            treeTypes={TreeTypes.Pine}
            position={[-8.645, -0.06, -4.5754]}
            rotation={[0, 0, 0]}
            scale={[0.373, 1.074, 0.373]} />
        <Tree
            treeTypes={TreeTypes.Pine}
            position={[-0.316, -0.06, -4.944]}
            rotation={[0, 20, 0]}
            scale={[0.373, 1.23791, 0.373]} />
        <Tree
            treeTypes={TreeTypes.Pine}
            position={[8.095, -0.06, -4.5754]}
            rotation={[0, 0, 0]}
            scale={[0.373, 1.074, 0.373]} />

        <Human
            animTimeScale={1.5}
            humanType={HumanTypes.farmer}
            animation={assets.human.animations.sit}
            idx={3}
            scale={1.2}
            position={[-0.30, -0.4, 0.85]}
            rotation={[0, MathUtils.DEG2RAD * 90, 0]}
        />
        <Human
            animTimeScale={1.5}
            humanType={HumanTypes.youngMan}
            animation={assets.human.animations.sit}
            idx={4}
            scale={1.2}
            position={[1.54, -0.4, 0.87]}
            rotation={[0, MathUtils.DEG2RAD * -90, 0]}
        />
        <Human
            animTimeScale={1.5}
            humanType={HumanTypes.youngWoman}
            animation={assets.human.animations.sit}
            idx={5}
            scale={1.2}
            position={[-0.6, -0.4, -1.04]}
            rotation={[0, MathUtils.DEG2RAD * 70, 0]}
        />
        <Human
            animTimeScale={0.5}
            humanType={HumanTypes.youngMan}
            animation={assets.human.animations.IdleApple}
            rotation={[0, MathUtils.DEG2RAD * 10, 0]}
            position={[-9, 0, -1.04]}
            idx={0}
        />
        <Horse
            idx={0}
            animTimeScale={0.5}
            animation={assets.horse.animations.IdleApple}
            hair={HorseHair.long}
            rotation={[0, MathUtils.DEG2RAD * 10, 0]}
            position={[-9, 0, -.8]}
            bodyTexture={assets.horse.textures.pitaBody}
            hairTexture={assets.horse.textures.pitaHair}
        />
    </>
}